import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BundleType, BundleTypeKeys, type RootState } from '@/store';

interface List {
  id: string;
  name: string;
}

interface BundleSectionsSuggestionsState {
  categoryList: List[];
  subCategoryList: List[];
}

const initialState: BundleSectionsSuggestionsState = {
  categoryList: [],
  subCategoryList: []
};

const bundleSectionsSuggestionsSlice = createSlice({
  name: 'bundleSectionsSuggestions',
  initialState: {
    [BundleType.LIGHT]: initialState,
    [BundleType.FULL]: initialState
  } as Record<BundleTypeKeys, BundleSectionsSuggestionsState>,
  reducers: {
    setBundleSectionsSuggestionsCategoryList: (state, action: PayloadAction<{ key: BundleTypeKeys; data: List[] }>) => {
      const { key, data } = action.payload;
      state[key].categoryList = data;
    },
    setBundleSectionsSuggestionsSubCategoryList: (
      state,
      action: PayloadAction<{ key: BundleTypeKeys; data: List[] }>
    ) => {
      const { key, data } = action.payload;
      state[key].subCategoryList = data;
    }
  }
});

export const { setBundleSectionsSuggestionsCategoryList, setBundleSectionsSuggestionsSubCategoryList } =
  bundleSectionsSuggestionsSlice.actions;

export const selectBundleSectionsSuggestionsCategoryList = (state: RootState) => {
  const activeBundleType = state.sharedData.activeBundleType;
  return activeBundleType ? state.bundleSectionsSuggestions[activeBundleType].categoryList : initialState.categoryList;
};
export const selectBundleSectionsSuggestionsSubCategoryList = (state: RootState) => {
  const activeBundleType = state.sharedData.activeBundleType;
  return activeBundleType
    ? state.bundleSectionsSuggestions[activeBundleType].subCategoryList
    : initialState.subCategoryList;
};

export const bundleSectionsSuggestionsReducer = bundleSectionsSuggestionsSlice.reducer;
